import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogContent, MatDialogActions, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog',
  standalone: true,
  imports: [MatDialogContent, MatDialogActions, MatButtonModule,CommonModule],
  templateUrl: './dialog.component.html',
  styleUrl: './dialog.component.scss'
})
export class DialogComponent {

  constructor(
    public dialogRef : MatDialogRef<DialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {title: string,text: string,type: string,actions:boolean}
  ) { }

  get icon() {
    switch (this.data.type) {
      case 'success':
        return 'assets/media/icons/success-icon.png';
      case 'info':
        return 'assets/media/icons/info-icon.png';
      case 'warning':
        return 'assets/media/icons/warning-icon.png';
      case 'danger':
        return 'assets/media/icons/error-icon.png';
      case 'collect':
        return 'assets/media/icons/money-icon.png';
      default:
        return 'assets/media/icons/info-icon.png';
    }
  }

  get color() {
    switch (this.data.type) {
      case 'success':
        return 'text-success';
      case 'info':
        return 'text-info';
      case 'warning':
        return 'text-warning';
      case 'danger':
        return 'text-danger';
      default:
        return 'text-dark';
    }
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
